export enum DefaultRoutes {
  AUTH = "/dashboard",
  NO_AUTH = "/login",
}

export const PAGE_TITLE_SUFFIX = "Digi Accounto";
